<template>
	<transition-group
		name="component-fade-slow"
		tag="div"
		class="alerts"
	>
		<core-alert
			v-for="(alert, index) in alerts"
			:key="'_' + index"
			:class="alert.type"
			:index="index"
			:close="alert.close"
			:closes="alert.closes"
			:icon="alert.icon"
		>
			<div
				class="alert-message"
				v-html="alert.message"
			>{{ alert.message }}</div>
		</core-alert>
	</transition-group>
</template>

<script>
export default {
	props : {
		alerts : {
			type     : Array,
			required : true
		},
	},
}
</script>